export default __webpack_public_path__ + "static/media/kolo_barva-min.fd0432f2.png";